var _rect, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGroupe(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 30,
    height: 30,
    fill: "url(#pattern0_2663_573)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("pattern", {
    id: "pattern0_2663_573",
    patternContentUnits: "objectBoundingBox",
    width: 1,
    height: 1
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#image0_2663_573",
    transform: "scale(0.0333333)"
  })), /*#__PURE__*/React.createElement("image", {
    id: "image0_2663_573",
    width: 30,
    height: 30,
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAB4AAAAeCAYAAAA7MK6iAAAACXBIWXMAAAsTAAALEwEAmpwYAAAEUklEQVRIiZ2XW4iVVRTHf6PTON41SvMSZU5iFyNTwdAuWJiWl65qplESRZikVA/VQw8+lBSRRpiCEFHeTbOsUCQ0S8yumuU1E8tLog42zmij/nrY6+Dp8J0zM27YnO/b39pr7f1f/3U5ZSolRjtgFXAMeAA4k/etOXApUAucKKUkc6il5gp1v3pEXaZWqH3UGervaq16TP1cva0BXRfF/gq1WSnBuepRtb16lVqn7oi139RX1CHqhDB8Sl2sXpuha5S6Oy6xX11XlgF1W2AWMAw4BPwdsHYFugEbgZFAfcG+W4HngP7AZ8AnwCBgANAL2A4sBDoCLxSerI26Xt2rdlM7q+PVserFcZsT6hK1eRGk+qgLwgWqs9X56hvxvZW6s3DTeyG8oojSBerZkNmgDo/DZsl2VPepj6jT1HdjvbO6q1nA1AKYAwwEJgJDgavzYBxMYnc/YAjwMFANfATsAZYCowugPw6cBlqG/v/5NGe4VWzcBqwByoH28W0ysBzoDnwLrAtfjQCuAaYCfwB3AR2A2cCVsbeMYiMPmip1j7pV/UVtqXYINj+pXqKeVBepd0RYFMLbQn06ZFF3BUeeVd+KtcosH99c4OPr1XpTOKEOC9/WmuJ4epCpWEhuV9eqG00h+HqQ7XiW8Mi42Yxg4El1UoHMlpi/qjXq+2rrApkJ6r/qZvWbOPAP6nfqwmIn7aseNIXAWPWfUP6S+qMpkXQK2UWB0lb1tZD5VD2sPlgMjVKZq0qtDjiHqOvC4Fy1S57c2+r36so4wI4w3K+E7gZz9dBQNr2EzE0BabU6ugF9jTac83mNOlNtG4buNhGxjTpRPa1ObaxRlaxcnTV6A6tJObuelL/bRXLoAowBVjRGUVYcNzSr4mYfxPvkcMOopty0KVDnz8Emhn8R8N93IUYbA3VPYBxwXUC8ntSFPAqsBGY2Cd68UcpwL1Je3gd8DFQA44FK4CFS3r7gUaZOAao4T5wzYWQE8CXwRJ58JTCPVJ3WA++Qikp1ky2rZ9SdppR2IGJySxCnqoiPhptqc42pFVqqDsyQK1N7qt2zyFWn3p7H1FUhXKv2iM1T4rlQcVd1jPqmqWu5X71RfVFdrv5kKhR71Zfz95aTCnSLAKAiIK/MuSJ++wFfBczlwPx4PwAsjrkPWEYq/gdJfdccYBPQA1hLahh2EEoa9AbwWDxvAiaRGF0NLAll24C+JL8/E+/n8nTUA2eB1rmFQsNlJHKdjOeWBd/nxuxBIt/jcaga4BRwJ7A7T/4yUrc6DdgA/Hz+OsmXOR8/FcR6Psh1IEg3ukQyuFy9wdR9oF5hytub1T/Vr4MjlYXkOm1qTfqrr4bBI7HxXlMdPmfqJHqXOMA96pog62FTLS/anWAKpTpTp1FnysVtTH85coID1NWBzjz1lmD0IHWW+pcptJYFOoXdSGbK7ESqNLlxKHyWNcaRusouQZhy4Cipzf2Q1G02avwHkARmaPhSEJcAAAAASUVORK5CYII="
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGroupe);
export default __webpack_public_path__ + "static/media/groupe.d30491068319e3db28390c162e8f6f37.svg";
export { ForwardRef as ReactComponent };